import PurifiedText from 'ui/src/components/PurifiedText';
import Image from 'ui/src/components/Image';
import Link from 'next/link';
import React from 'react';
import TrackImage from './_TrackImage';
import MainContainer from '../MainContainer';

export default function ErrorPage() {
  return (
    <MainContainer className="pb-40 pt-20 md:h-[calc(100vh-6.5rem)] md:pb-0 md:pt-32">
      <section className="mx-auto flex  flex-col-reverse items-center justify-between md:flex-row">
        <div className="flex flex-col gap-6">
          <h6 className="site-paragraph-s text-site-neutrals-500 font-bold tracking-[.2em]">500 ERROR</h6>

          <PurifiedText
            as="h1"
            className="site-display-2xl text-site-neutrals-700 [&_strong]:text-site-primary-600 font-medium"
          >
            {'Well, this is unexpected<strong>.</strong>'}
          </PurifiedText>

          <span>
            Oops! There&apos;s a problem with the website&apos;s server. It&apos;s not your fault. Our tech team is
            working on fixing it.
          </span>

          <div className="flex flex-col">
            <p className="font-bold">What you can do:</p>

            <ul className="list-disc px-10">
              <li>Try reloading the page later</li>

              <li>
                Go to our{' '}
                <Link href="https://www.bairesdev.com/" className="underline" prefetch={false}>
                  Homepage
                </Link>
              </li>

              <li>
                Learn about our{' '}
                <Link
                  href="https://www.bairesdev.com/software-development-services/"
                  className="underline"
                  prefetch={false}
                >
                  Services
                </Link>
              </li>

              <li>
                Check our{' '}
                <Link href="https://www.bairesdev.com/blog/" className="underline" prefetch={false}>
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <span>Thank you for understanding!</span>
        </div>

        <figure className="relative h-[15rem] w-[15rem] md:h-[24rem] md:w-[24rem] lg:h-[37rem] lg:w-[37rem]">
          <Image
            alt=""
            src="https://assets.bairesdev.com/image/upload/www/static/basics/500error_cmryub"
            fill
            preload
            sizes={{ base: '15rem' }}
            className="object-cover"
          />
        </figure>
      </section>
      <TrackImage />
    </MainContainer>
  );
}
